export default {"src":"/_next/static/media/insta-icon.f69d1372.svg","height":21,"width":20};